export const wait = (waitTime: number): Promise<void> => {
  return new Promise((resolve) => setTimeout(resolve, waitTime));
};
